<template>
  <v-form
    ref="form"
    lazy-validation
    class="pr-md-24"
    @submit.prevent="createBrand"
  >
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'brand-index' })"
      >
        <v-icon left>
          arrow_back
        </v-icon>
        Back
      </v-btn>
    </div>
    <v-card elevation="0" outlined class="pr-md-24 pl-md-4 mb-10 pt-4">
      <v-container>
        <v-row class="pa-a">
          <v-col class="mb-0 pb-0" cols="6" md="6">
            <v-text-field
              outlined
              :rules="nameRules"
              label="Name"
              v-model="brand.name"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="text-center mb-0">
              <image-picker
                v-model="brand.logo"
                :add="brand.logo === null"
                :uploaded="brand.logo !== null"
                @delete-item="brand.logo = null"
                @reset="brand.logo = null"
              >
                <div slot="activator" class="cursor-pointer w-100 h-100">
                  <img
                    :src="brand.logo"
                    alt="avatar"
                    width="100%"
                    height="100%"
                    v-if="brand.logo"
                  />
                </div>
              </image-picker>
            </div>
          </v-col>
          <v-col cols="0" md="6" class="pa-0"></v-col>
        </v-row>
        <div class="text-left">
          <v-btn type="submit" color="accent" class="mx-0 mt-4">Create</v-btn>
        </div>
      </v-container>
    </v-card>
  </v-form>
</template>
<script>
import ImagePicker from "@/components/ImagePicker.vue";
export default {
  data() {
    return {
      brand: {
        name: null,
        logo: null
      },
      rules: [
        value =>
          !value ||
          value.size < 2000000 ||
          "Avatar size should be less than 2 MB!"
      ],
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length >= 5) || "Name must be at least 5 characters",
        v =>
          (v && v.length <= 35) || "Name must be less than than 35 characters"
      ]
    };
  },
  components: {
    ImagePicker
  },
  methods: {
    loadLogo(event) {
      this.brand.logo = event.target.files[0];
    },
    async createBrand() {
      let formdata = new FormData();
      formdata.append("name", this.brand.name);
      formdata.append("logo", this.brand.logo);
      this.$swal({
        title: "Adding product brand...",
        html: "this will only take a moment...",
        icon: "info",
        didOpen: () => {
          this.$swal.showLoading();
        }
      });
      await this.$store.dispatch("brands/CREATE_BRAND", formdata);
      this.$swal.close();
      this.$swal({
        title: "Success",
        html: "Product brand has been added",
        icon: "success"
      });
    }
  }
};
</script>
